import { z } from 'zod';
import { IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
// T7-003 — `qbo_oauth_state` added for the QuickBooks Online OAuth flow.
// Used by the anti-CSRF state token minted on POST /oauth/initiate and
// validated on GET /oauth/callback. oneTimeUse=true, TTL=10 minutes.
// The mintReason JSON carries `{ returnTo?: string }` so the callback
// can redirect back to a UI surface the initiator specified.
export const TokenScopeSchema = z.enum([
    'intake',
    'portal',
    'msa_review',
    'proposal_acceptance',
    'qbo_oauth_state',
]);
export const TokenSchema = z.object({
    id: z.string(),
    type: z.literal('token'),
    schemaVersion: SchemaVersionSchema,
    accountId: IDSchema,
    scope: TokenScopeSchema,
    expiresAt: IsoTimestampSchema,
    oneTimeUse: z.boolean().default(true),
    usedAt: IsoTimestampSchema.optional(),
    usedFromIp: z.string().optional(),
    mintedBy: z.string(),
    mintedAt: IsoTimestampSchema,
    mintReason: z.string(),
    tokenHash: z.string(),
    createdAt: IsoTimestampSchema,
    // T1-005 — added alongside the Drizzle schema's updatedAt addition so
    // versioned-entity pattern (and Zod-Drizzle drift checker) holds.
    updatedAt: IsoTimestampSchema,
    version: z.number().int().positive(),
});
//# sourceMappingURL=token.js.map